var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { makeImmutable, Quantity } from "../../core";
import { perRestaurant } from "../../di";
import { RArray } from "../../collections";
import { Price } from "../Price";
import { ModifierItemInstancePriceService } from "./ModifierItemInstancePriceService";
let ModifierInstancePriceService = class ModifierInstancePriceService {
    constructor(modifierItemInstancePriceService) {
        this.modifierItemInstancePriceService = modifierItemInstancePriceService;
        makeImmutable(this);
    }
    addedQuantity(modifierItem) {
        if (modifierItem.defaultQuantity.geq(modifierItem.quantity)) {
            return Quantity.Zero;
        }
        return modifierItem.quantity.sub(modifierItem.defaultQuantity);
    }
    removedQuantity(modifierItem) {
        if (modifierItem.quantity.geq(modifierItem.defaultQuantity)) {
            return Quantity.Zero;
        }
        return modifierItem.defaultQuantity.sub(modifierItem.quantity);
    }
    removedPrice(modifierItem, parameterScope) {
        const removedPrice = this.modifierItemInstancePriceService.unitPrice(modifierItem, parameterScope);
        if (removedPrice.hasPossibleValues) {
            const removedQuantity = this.removedQuantity(modifierItem);
            return removedPrice.multiply(removedQuantity);
        }
        return Price.free();
    }
    addedItemPrices(exchangePolicy, modifierItems, parameterScope) {
        switch (exchangePolicy) {
            case "NotIncluded":
                return modifierItems.flatMap((modifierItemInstanceParams) => RArray.repeat(this.modifierItemInstancePriceService.unitPrice(modifierItemInstanceParams, parameterScope), modifierItemInstanceParams.quantity));
            case "AdditionOnly":
            case "ExchangeWithClamp":
            case "UnlimitedExchange":
                return modifierItems.flatMap((modifierItemInstanceParams) => {
                    return RArray.repeat(this.modifierItemInstancePriceService.unitPrice(modifierItemInstanceParams, parameterScope), this.addedQuantity(modifierItemInstanceParams));
                });
        }
    }
    removedItemsPrice(exchangePolicy, modifierItems, parameterScope) {
        switch (exchangePolicy) {
            case "NotIncluded":
            case "AdditionOnly":
                return Price.free();
            case "ExchangeWithClamp":
            case "UnlimitedExchange": {
                const removedPrices = modifierItems.map((modifierItemInstanceParams) => this.removedPrice(modifierItemInstanceParams, parameterScope));
                return Price.total(removedPrices);
            }
        }
    }
    modifierInstancePrice(exchangePolicy, modifierItems, freeItems, parameterScope) {
        const addedItemPrices = this.addedItemPrices(exchangePolicy, modifierItems, parameterScope)
            .sorted((a, b) => -1 * a.compare(b))
            .sliceAt(freeItems.value)[1];
        const addedItemsPrice = Price.total(addedItemPrices);
        const removedItemsPrice = this.removedItemsPrice(exchangePolicy, modifierItems, parameterScope);
        const finalPrice = addedItemsPrice.sub(removedItemsPrice);
        switch (exchangePolicy) {
            case "NotIncluded":
            case "UnlimitedExchange":
            case "AdditionOnly":
                return finalPrice;
            case "ExchangeWithClamp":
                return finalPrice.max(Price.free());
        }
    }
    price(modifierInstance, parameterScope) {
        return this.modifierInstancePrice(modifierInstance.modifierType.exchangePolicy, modifierInstance.items.objects, modifierInstance.freeItems, parameterScope);
    }
};
ModifierInstancePriceService = __decorate([
    perRestaurant(),
    __metadata("design:paramtypes", [typeof (_a = typeof ModifierItemInstancePriceService !== "undefined" && ModifierItemInstancePriceService) === "function" ? _a : Object])
], ModifierInstancePriceService);
export { ModifierInstancePriceService };
